import React from "react";
import Divider from './Divider';
import stcjmis from '../assets/img/stcjmis.png';
import '../css/AboutUs.css';

const CoreValues = () => {
    const heading1 = 'MISSION';
    const heading2 = 'VISION';
    const heading3 = 'The St. Therese of the Child Jesus Multiple Intelligence School Hymn';
    const content1 = 'Lorem ipsum odor amet, consectetuer adipiscing elit. Curabitur eros quis neque quisque; porta malesuada varius est. Ex vehicula taciti nulla per vivamus at potenti dapibus. Primis duis hac convallis nec bibendum vel venenatis parturient. Sodales pulvinar per nam nam dui, facilisi ipsum ex fames. Cursus aliquet fringilla tempor vel sociosqu turpis praesent varius.';
    const content2 = 'Lorem ipsum odor amet, consectetuer adipiscing elit. Curabitur eros quis neque quisque; porta malesuada varius est. Ex vehicula taciti nulla per vivamus at potenti dapibus. Primis duis hac convallis nec bibendum vel venenatis parturient. Sodales pulvinar per nam nam dui, facilisi ipsum ex fames. Cursus aliquet fringilla tempor vel sociosqu turpis praesent varius.';
    const content3 = 'Lorem ipsum odor amet, consectetuer adipiscing elit. Curabitur eros quis neque quisque; porta malesuada varius est. Ex vehicula taciti nulla per vivamus at potenti dapibus. Primis duis hac convallis nec bibendum vel venenatis parturient. Sodales pulvinar per nam nam dui, facilisi ipsum ex fames. Cursus aliquet fringilla tempor vel sociosqu turpis praesent varius.';
    
    return(
        <div className="core-values-container">
            <div className="section-container">
                <div className="vertical-section-50 flex-center">
                    <div className="left-pane flex-center">
                        <div className='heading palanquin-dark bold primary-yellow-text'>
                            {heading1}
                        </div>
                        <Divider width='320' color='#FFFFFF' />
                    </div>
                    <div className="right-pane">
                        <div className="secondary-white-text palanquin-dark regular center-text content">
                            {content1}
                        </div>
                    </div>
                </div>
                <div className="vertical-section-50 flex-center">
                    <div className="left-pane flex-center">
                        <div className='heading palanquin-dark bold primary-yellow-text'>
                            {heading2}
                        </div>
                        <Divider width='270' color='#FFFFFF' />
                    </div>
                    <div className="right-pane">
                        <div className="secondary-white-text palanquin-dark regular center-text content">
                            {content2}
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-container tertiary-white-background hymn-container flex-center">
                <div className="left-pane horizontal-pane-50 flex-center">
                    <img
                        className=""
                        src={stcjmis}
                        alt="stcjmis-logo"
                    />
                </div>
                <div className="right-pane horizontal-pane-50 tertiary-blue-text">
                    <div className="text-container">
                        <div className="palanquin-dark bold heading3 center-text hymn-heading">{heading3}</div>
                        <div className="palanquin-dark regular content center-text">
                            {content3}
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    )
}

export default CoreValues;